import * as React from "react";
import {MouseEvent} from "react";
import {connect} from "react-redux";
import Feed from "../../_data/models/Feed";
import {FeedsRoutes, UsersRoutes} from "../../routes";
import ActivityFeedItemComponent from "../components/ActivityFeedItemComponent";
import {push} from "react-router-redux";
import {toggleLikeFeed} from "../middlewares";
import {shopByIdSelector, userByIdSelector} from "../../_data/selectors";
import {feedModelSelector} from "../selectors";
import {clearComments} from "../../comment/actions";
import Booth from "../../_data/models/Booth";
import Style from "../../_data/models/Style";
import Special from "../../_data/models/Special";

interface Props {
    feed: Feed;
    currentUserID: number;
}

const mapStateToProps = (state, props: Props) => {
    const {feed} = props;
    const model = feedModelSelector(state, feed);
    let user;
    if (model instanceof Booth) {
        const shop = shopByIdSelector(state, (model as Booth).shopId);
        user = userByIdSelector(state, shop.userId);
    } else
        user = userByIdSelector(state, (model as Style | Special).userId);

    return {
        model: model,
        user: user
    }
};

const mapDispatchToProps = (dispatch, props: Props) => {
    const {feed, currentUserID} = props;

    return {
        viewFeed: () => {
            if (feed.resource == 'style') {
                dispatch(clearComments());
                dispatch(push(FeedsRoutes.preview(feed.id), {refresh: false}));
            }
        },
        toggleLike: (e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            if (!currentUserID)
                return window.location.replace(UsersRoutes.sign_in());
            dispatch(toggleLikeFeed(feed));
        },
    }
};

const ActivityFeedItemContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(ActivityFeedItemComponent);
export default ActivityFeedItemContainer;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/containers/ActivityFeedItemContainer.tsx